<div class="content">
  <div class="row">
    <div class="col-10">
      <h3>Providers</h3>
    </div>

    <div class="col-2 page-actions">
      <button type="submit" class="btn btn-primary" (click)="onAddProviderClick($event)">Add Provider</button>
    </div>
  </div>

  <div class="container-fluid p-1 my-2 px-3 border rounded bg-light">
    <form novalidate>
      <div class="row small-gutters my-1">
        <div class="col-3">
          <label for="firstName">First Name:</label>
          <input
            id="firstName"
            class="form-control"
            name="firstName"
            placeholder="Filter By First Name"
            [(ngModel)]="filters.firstName"
            (input)="onTextFilterChange()">
        </div>
        <div class="col-3">
          <label for="lastName">Last Name:</label>
          <input
            id="lastName"
            class="form-control"
            name="lastName"
            placeholder="Filter By Last Name"
            [(ngModel)]="filters.lastName"
            (input)="onTextFilterChange()">
        </div>
        <div class="col-3">
          <label for="npi">NPI:</label>
          <input
            id="npi"
            class="form-control"
            name="npi"
            placeholder="Filter By NPI"
            [(ngModel)]="filters.npi"
            (input)="onTextFilterChange()">
        </div>
        <div class="col-3">
          <label for="city">City:</label>
          <input
            id="city"
            class="form-control"
            name="city"
            placeholder="Filter By City"
            [(ngModel)]="filters.city"
            (input)="onTextFilterChange()">
        </div>
      </div>
      <div class="row small-gutters my-1">
        <div class="col-3">
          <label for="state">State:</label>
          <ng-select
            bindValue="value"
            bindLabel="display"
            [(ngModel)]="filters.state"
            [items]="stateOptions"
            placeholder="Filter By State"
            name="state"
            (change)="onFilterChange()" />
        </div>
        <div class="col-3">
          <label for="status">Status:</label>
          <ng-select
            bindValue="value"
            bindLabel="display"
            [(ngModel)]="filters.status"
            [items]="providerStatusOptions"
            name="status"
            [multiple]="true"
            placeholder="Filter By Status"
            (remove)="onFilterChange()"
            (change)="onFilterChange()" />
        </div>
      </div>
    </form>
  </div>

  @if (!loading) {
    <div class="mt-2">
      <app-pagination-header
        [paging]="paging"
        [label]="'providers'"
        (pageSizeChange)="onPageSizeChange($event)"
        [includeResetFiltersButton]="true"
        (resetFiltersClick)="onResetFiltersClick()" />
      @if (providers.length > 0) {
        <div class="mt-2">
          <table class="table table-bordered table-hover">
            <thead class="table-dark">
              <tr>
                <th>NPI</th>
                <th>NAME</th>
                <th>SPECIALTIES</th>
                <th>STATES</th>
                <th>CLIENTS</th>
                <th>REVIEW STATUS</th>
                <th>UPDATED</th>
              </tr>
            </thead>
            <tbody>
              @for (provider of providers; track provider) {
                <tr>
                  <td>
                    <a
                      routerLink="/capture-admin/providers/{{provider.npi}}"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }">
                      {{ provider.npi }}
                      <app-copy-to-clipboard [text]="provider.npi" />
                    </a>
                  </td>
                  <td>
                    @if (provider.fullName) {
                      <div>
                        {{ provider.fullName }}
                        <app-copy-to-clipboard [text]="provider.fullName" />
                      </div>
                    }
                    @if (!provider.fullName) {
                      <app-blank-value-dash />
                    }
                  </td>
                  <td>
                    {{ provider.specialties.join(', ') | blankValueDash }}
                  </td>
                  <td>
                    {{ provider.captureClientStates?.join(', ') | blankValueDash }}
                  </td>
                  <td>
                    {{ provider.captureClientNames?.join(', ') | blankValueDash }}
                  </td>
                  <td>
                    @if (keyedStatusOptions[provider.status]) {
                      {{ keyedStatusOptions[provider.status].display }}
                    } @else {
                      {{ provider.status }}
                    }
                  </td>
                  <td>
                    {{ provider.updatedAt | date: 'MM/dd/yyyy' }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <div class="mt-2">
            <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
          </div>
        </div>
      } @else {
        <p class="ms-1">No providers.</p>
      }
    </div>
  } @else {
    @if (loading) {
      <div class="ms-1"><mat-spinner diameter="30" /></div>
    }
  }
</div>


